export const OBSERVABILITY_EMPTY_VALUE = '';
export const OBSERVABILITY_UNKNOWN_VALUE = 'unknown';
